/**
 * Bottom fade shared by every hero.
 *
 * The heroes sit on top of the page-wide `.lb-canvas` gradient. Ending them on a
 * flat black band leaves a faint horizontal edge, because the canvas underneath
 * has already lifted to a dark navy by that point. Masking the artwork layer
 * instead dissolves the hero into whatever is behind it, so there is no colour to
 * match and it holds at any hero height or page length.
 *
 * The stops are weighted to ease out (slow, then quick) rather than fade
 * linearly, since a straight two-stop ramp reads as a visible grey wash.
 */
const HERO_FADE =
  'linear-gradient(to bottom, #000 0%, #000 68%, rgba(0,0,0,0.86) 79%, rgba(0,0,0,0.52) 88%, rgba(0,0,0,0.2) 95%, rgba(0,0,0,0) 100%)';

/** Spread onto the hero's artwork layer (not the section, which would fade the copy too). */
export const heroFadeStyle = {
  maskImage: HERO_FADE,
  WebkitMaskImage: HERO_FADE,
};

export default HERO_FADE;
